import { NgxsSimpleChange } from '@ngxs/store'

// True when a state change altered something worth writing to storage.
//
// Every slice persists itself from ngxsOnChanges by stringifying the whole
// model and handing it to Ionic Storage. That fires on every change, and a
// Refresh produces two of them: patchState({is_refreshing: true}) on the way
// in, then Set/Merge with the rows on the way out. The first carries no new
// rows -- only the spinner flag -- so it rewrites the entire slice for nothing.
// On units that is a 3.6 MB serialise and IndexedDB write per refresh, thrown
// away immediately by the second one.
//
// The stored flag is not lost by skipping the write: every slice's Init action
// overwrites the persisted is_refreshing with the live value when it rehydrates
// from storage, so what was written there was never read back.
//
// Comparison is by reference per field, which is exact here because ngxs state
// is immutable -- a slice whose rows actually changed arrives with a new array.
export function stateContentChanged(change: NgxsSimpleChange): boolean {
  const previous = change?.previousValue
  const current = change?.currentValue
  // First change of the session, or a shape we don't recognise: persist it.
  if (!previous || !current) return true

  const keys = new Set([...Object.keys(previous), ...Object.keys(current)])
  keys.delete('is_refreshing')
  for (const key of keys) {
    if (previous[key] !== current[key]) return true
  }
  return false
}
